import Minimize from '../../../assets/minimize.svg';

const MinimizeIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Minimize fill={'#0090E3'} {...props} />;
};

export default MinimizeIcon;
